/**
 * @generated SignedSource<<faa23f61f454a869556be744e8bb3c8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateNovaAgentCategoryInput = {
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateNovaAgentCategoryMutation$variables = {
  input: CreateNovaAgentCategoryInput;
};
export type CreateNovaAgentCategoryMutation$data = {
  readonly createNovaAgentCategory: {
    readonly category: {
      readonly id: string;
      readonly name: string | null;
      readonly isUncategorised: boolean | null;
    } | null;
  } | null;
};
export type CreateNovaAgentCategoryMutation = {
  variables: CreateNovaAgentCategoryMutation$variables;
  response: CreateNovaAgentCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateNovaAgentCategoryPayload",
    "kind": "LinkedField",
    "name": "createNovaAgentCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgentCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUncategorised",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateNovaAgentCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateNovaAgentCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3d284ebb5084f9efffc7a3183105e3f",
    "id": null,
    "metadata": {},
    "name": "CreateNovaAgentCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation CreateNovaAgentCategoryMutation(\n  $input: CreateNovaAgentCategoryInput!\n) {\n  createNovaAgentCategory(input: $input) {\n    category {\n      id\n      name\n      isUncategorised\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91ea56188ad3f3d57389c66c5aabef70";

export default node;
